import React, { useEffect, useState } from 'react';
import OrganizationInvoices from '../OrganizationInvoices';
import organizationsService from '../../services/organizationsService';

// ── Billing ──────────────────────────────────────────────────────────────────

export function BillingSummaryTab({ org, canEdit }) {
  const [billing, setBilling] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await organizationsService.getBilling(org.id);
        if (!cancelled) setBilling(data);
      } catch (e) {
        // Billing is owner/admin only server-side; a plain member gets a 403
        // here rather than an empty panel that looks broken.
        if (!cancelled) setError(e.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [org.id]);

  if (error) return <p className="org-hint">{error}</p>;
  if (!billing) return <p className="org-hint">Loading…</p>;

  return (
    <div className="org-form">
      <div className="org-billing-grid">
        <div>
          <span className="org-field-label">Plan</span>
          <p className="org-billing-value">{billing.plan}</p>
        </div>
        <div>
          <span className="org-field-label">Seats</span>
          {/* Distinct people across every team in the organisation — someone in
              three teams is one seat. */}
          <p className="org-billing-value">{billing.seats}</p>
        </div>
        <div>
          <span className="org-field-label">Renews</span>
          <p className="org-billing-value">
            {billing.plan_expires_at
              ? new Date(billing.plan_expires_at).toLocaleDateString()
              : '—'}
          </p>
        </div>
      </div>

      {!billing.subscribed && (
        <p className="org-hint">
          This organization has no subscription yet. Its teams are still billed to their
          own owners until one is set up.
        </p>
      )}

      {canEdit && billing.subscribed && (
        <button
          type="button"
          className="org-btn"
          onClick={async () => {
            try {
              const url = await organizationsService.createPortalSession(
                org.id,
                window.location.href
              );
              if (url) window.open(url, '_blank', 'noopener,noreferrer');
            } catch {
              setError('Could not open the billing portal.');
            }
          }}
        >
          Manage billing
        </button>
      )}

      {/* Only once there is a subscription: an organisation that has never been
          billed has no invoices, and an empty "Invoices" heading reads as
          something failing to load. */}
      {billing.subscribed && <OrganizationInvoices orgId={org.id} />}
    </div>
  );
}
